export default "__VITE_ASSET__MKMk9VpS__"